import { computed, inject } from "vue";
import {
  buildQuestionBodyAnchor,
  buildStimulusAnchor,
  buildSuggestedAnswerAnchor,
} from "@modules/annotation/service/annotation.anchor.utils.ts";
import { isDefined } from "@utils/var.check";

export interface QuestionContext {
  anchor?: () => string | undefined;
  componentId?: number;
}

export function useQuestionAnnotation() {
  const questionContext = inject<QuestionContext>("questionContext", {});

  const questionAnchor = computed(() => questionContext.anchor?.() ?? "");

  const questionBodyAnchor = computed(() =>
    questionAnchor.value ? buildQuestionBodyAnchor(questionAnchor.value) : "",
  );

  const stimulusAnchor = computed(() =>
    questionAnchor.value ? buildStimulusAnchor(questionAnchor.value) : "",
  );

  const suggestedAnswerAnchor = computed(() =>
    questionAnchor.value ? buildSuggestedAnswerAnchor(questionAnchor.value) : "",
  );

  const questionAnnotationResourceId = computed(() =>
    isDefined(questionContext.componentId) ? String(questionContext.componentId) : "",
  );

  return {
    questionAnchor,
    questionBodyAnchor,
    stimulusAnchor,
    suggestedAnswerAnchor,
    questionAnnotationResourceId,
  };
}
